import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { FileEntity } from './file.entity';

@Index('_fk__cron__id_first', ['fkCronIdFirst'], {})
@Index('_fk__file__id', ['fkFileId'], {})
@Entity('_import_export')
export class ImportExportEntity extends BaseEntity {
	@Column('varchar', { name: '_type', nullable: true, length: 255 })
	public type!: string | null;

	@Column('int', { name: '_fk__file__id', unsigned: true })
	public fkFileId!: number;

	@Column('varchar', { name: '_status', nullable: true, length: 16 })
	public status!: string | null;

	@Column('text', { name: '_result', nullable: true })
	public result!: string | null;

	@Column('int', {
		name: '_fk__cron__id_first',
		nullable: true,
		unsigned: true,
	})
	public fkCronIdFirst!: number | null;

	@ManyToOne(() => FileEntity, (file) => file.importExports, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__file__id', referencedColumnName: 'id' }])
	public fkFile!: FileEntity;
}
